import React from 'react';

const SvgMarkerTripEnd = ({ svgRef, title, ...props }) => (
  <svg width="1em" height="1em" viewBox="0 0 30 44" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path id="MarkerTripEnd_svg__a" d="M730 471c-8.293 0-15 6.886-15 15.4 0 11.55 15 28.6 15 28.6s15-17.05 15-28.6c0-8.514-6.707-15.4-15-15.4" />
    </defs>
    <use width="100%" height="100%" xlinkHref="#MarkerTripEnd_svg__a" transform="translate(-715 -471)" fill="#2fa0a0" />
    <path d="M22.505 22.495h-15v-15h15z" fill="#fff" stroke="#000" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M22.505 22.495v-5h-5v5zm-5-5v-5h-5v5zm-5 0h-5v5h5zm0-5v-5h-5v5zm5 0h5v-5h-5z" stroke="#000" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgMarkerTripEnd svgRef={ref} {...props} />);
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/MarkerTripEnd.js